<template>
  <div class="excel-import">
    <input
      type="file"
      ref="fileInput"
      class="hidden"
      accept=".xlsx, .xls"
      @change="handleClick"
    >
    <div
      @click="confirmPopup"
      @drop="handleDrop"
      @dragover="handleDragover"
      @dragenter="handleDragover"
      class="
        px-8 py-16 cursor-pointer text-center border-2 border-dashed d-theme-border-grey-light
        d-theme-dark-bg text-xl"
    >
      <feather-icon icon="UploadCloudIcon" svgClasses="h-16 w-16 stroke-current text-grey" class="block" />
      <span>Arraste um Arquivo Excel ou </span>
      <span class="font-medium text-primary" @click.stop="$refs.fileInput.click()">Procure Aqui</span>
      <!-- <vs-button type="border" @click.stop="$refs.fileInput.click()">Browse</vs-button> -->
    </div>
  </div>
</template>

<script>
import XLSX from 'xlsx'
import axios from 'axios'

import { removeFileFromBucket } from '@/utils'

export default {
  props: {
    onSuccess: {
      type: Function,
      required: true
    },
    fileName: {
      type: String,
      required: true
    },
    action: {
      default: null,
      type: String
    },
    headers: {
      default: null,
      type: Object
    },
    maxRowsToImport: {
      type: Number,
      required: false
    },
    confirmMessage: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      excelData: {
        header: null,
        results: null,
        meta: null
      }
    }
  },
  methods: {
    confirmPopup() {
      if (this.confirmMessage === undefined) {
        this.$refs.fileInput.click()
      } else {
        this.$vs.dialog({
          type:'confirm',
          color: 'primary',
          title: `Atenção!`,
          text: this.confirmMessage,
          accept: () => this.$refs.fileInput.click(),
          acceptText: 'Entendi',
          cancelText: 'Voltar',
        })
      }
    },
    generateData({ header, results, meta }, fileUrl) {
      if (this.maxRowsToImport !== undefined && results.length > this.maxRowsToImport) {
        removeFileFromBucket(fileUrl).then(() => {
          this.$vs.notify({
            color: 'warning',
            title: 'Atenção!',
            text: `Não é possível adicionar mais que ${this.maxRowsToImport} clientes em uma Categoria`,
            time: 5000
          })
        })
      } else {
        this.excelData.header = header
        this.excelData.results = results
        this.excelData.meta = meta
        this.onSuccess && this.onSuccess(this.excelData)
      }
    },
    getHeaderRow(sheet) {
      const headers = []
      const range = XLSX.utils.decode_range(sheet['!ref'])
      let C
      const R = range.s.r
      /* start in the first row */
      for (C = range.s.c; C <= range.e.c; ++C) { /* walk every column in the range */
        const cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })]
        /* find the cell in the first row */
        let hdr = 'UNKNOWN ' + C // <-- replace with your desired default
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell)
        headers.push(hdr)
      }
      return headers
    },
    handleDragover(e) {
      e.stopPropagation()
      e.preventDefault()
      e.dataTransfer.dropEffect = 'copy'
    },
    handleDrop(e) {
      e.stopPropagation()
      e.preventDefault()
      const files = e.dataTransfer.files
      if (files.length !== 1) {
        this.$vs.notify({
            title: 'Login Attempt',
            text: 'Only support uploading one file!',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
        })
        return
      }
      const rawFile = files[0] // only use files[0]
      if (!this.isExcel(rawFile)) {
        this.$vs.notify({
            title: 'Login Attempt',
            text: 'Only supports upload .xlsx, .xls, .csv suffix files',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
        })
        return false
      }
      this.uploadFile(rawFile)
    },
    readerData(rawFile, fileUrl) {
      return new Promise((resolve) => {
        const reader = new FileReader()
        reader.onload = e => {
          const data = e.target.result;
          const workbook = XLSX.read(data, { type: 'array', cellDates:true});
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          const header  = this.getHeaderRow(worksheet);
          const results = this.formatData(XLSX.utils.sheet_to_json(worksheet, {raw:true}));

          let parsedHeader;
          let parsedResults;

          try {

            parsedHeader = header.filter(
              key => !key.includes("UNKNOWN")
            );

            let maxLength = 0;

            parsedResults = results.map(
              item => {
                const newObject = {};

                const newKeys = Object.keys(item).filter(
                  key => !key.includes("UNKNOWN")
                );

                newKeys.forEach(
                  key => {
                    newObject[key] = item[key];
                  }
                );

                const realLength = newObject ? Object.keys(newObject).length - 1 : false;

                if (
                  realLength &&
                  realLength > maxLength
                ) maxLength = realLength;

                return newObject;
              }
            );

            if ( maxLength > parsedHeader.length ) throw '';

          } catch (error) {
            parsedHeader  = header;
            parsedResults = results;
          }

          const meta = { sheetName: firstSheetName };
          this.generateData(
            {
              header: parsedHeader,
              results: parsedResults,
              meta
            }, fileUrl
          );
          resolve(parsedResults.length);
        }
        reader.readAsArrayBuffer(rawFile)
      })
    },
    formatData(xlsx){
      let row = 0;
      return xlsx.map(r => {
        var o = Object.assign({}, r);
        Object.entries(r).forEach(([k,v]) => {
          if(v && v instanceof Date) o[k] = v.toLocaleDateString();
        });
        o['__rowNum__'] = row++;
        return o
      });
    },
    handleClick(e) {
      const files = e.target.files
      const rawFile = files[0]
      if (!rawFile) return
      this.uploadFile(rawFile)
    },
    isExcel(file) {
      return /\.(xlsx|xls|csv)$/.test(file.name)
    },
    uploadFile(file) {
      this.$vs.loading({
        type: 'radius'
      });
      this.$refs['fileInput'].value = null// fix can't select the same excel
      
      if (this.maxRowsToImport === undefined) {
        this.readerData(file, '')
      }

      const formData = new FormData();
      formData.append(this.fileName, file, file.name)
      this.uploadx(formData, file)
    },
    uploadx(formData, file) {
      let self = this
      

      const headers = this.headers || {};
      headers['Content-Type'] = `multipart/form-data; boundary=${formData._boundary}`

      axios.post(this.action, formData, {
        headers
      })
      .then((response) => {
        const responseData = response
        this.$vs.loading.close()

        if (this.maxRowsToImport !== undefined) {
          this.readerData(file, responseData.data.fileUrl).then(importedRows => {
            if (importedRows <= this.maxRowsToImport) {
              self.$emit('on-success', responseData)
            }
          })
        } else {
          self.$emit('on-success', responseData)
        }
      })
      .catch((error) => {
        this.$vs.loading.close()
        self.$emit('on-error', error.response)
      })
    }
  }
}
</script>
